// extracted by mini-css-extract-plugin
export default {"section":"styles_section__O8vHh","triplet":"styles_triplet__NJEjP","input":"styles_input__ggh4N","termSelector":"styles_termSelector__+QMJ5","datePicker":"styles_datePicker__QI5KE"};